export default __webpack_public_path__ + "static/media/download-icon.79a70193.svg";